import { useEffect } from "react";
import { getPartners } from "../../services/Api/superadminService";
import { useSuperAdminPartnerStore } from "../../stores/superadmin/superadminpartner";
import { useSuperAdminCreatePartnerStore } from "../../stores/superadmin/createPartner";
import { useSuperAdminLogsStore } from "../../stores/superadmin/logs";
import useModal from "../../hooks/useModal";
import NavBarSuperAdmin from "../../components/SuperAdmin/NavBarSuperAdmin";
import SuperAdminLogsTable from "../../components/SuperAdmin/SuperAdminLogsTable";
import SuperAdminPartnerTable from "../../components/SuperAdmin/SuperAdminPartnerTable";
import { ToastContainer } from "react-toastify";
import Header from "../../components/Layout/Header";
import { showToastError } from "../../services/Toasts/toasts";

const SuperAdminHome = () => {
  // Store
  const { setPartners, pathVisible, setModePartner, sendData } =
    useSuperAdminPartnerStore();
  const { openDetails, setOpenDetails, setDisplayDiv } =
    useSuperAdminCreatePartnerStore();

  // Hook
  const { modalContent, isModalOpen, openModal, closeModal } = useModal();
  const { handleDownloadLogs } = useSuperAdminLogsStore();

  useEffect(() => {
    getPartners()
      .then((res) => {
        const sortedData = res?.data.sort((a: any, b: any) => a.id - b.id);
        setPartners(sortedData);
      })
      .catch(() => showToastError("Une erreur s'est produite"));
  }, [sendData]);

  return (
    <div className="w-screen h-screen bg-gradient-to-br from-slate-50 to-blue-50 flex flex-col justify-start items-start overflow-hidden">
      {isModalOpen ? modalContent : null}
      <ToastContainer position="top-center" />
      <Header />
      
      <div className="w-full h-full flex justify-start items-start">
        <NavBarSuperAdmin />
        <div className="flex flex-col justify-start items-center w-11/12 h-screen m-auto">
          
          {/* Section Partenaires */}
          {pathVisible === "partners" && (
            <>
              {/* Header Section avec design moderne */}
              <div className="w-full bg-white rounded-2xl shadow-lg p-6 my-6 border border-gray-100">
                <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6">
                  <div className="flex items-center gap-4">
                    <div className="p-3 bg-gradient-to-br from-light-lavender to-dark-lavender rounded-xl shadow-lg">
                      <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                      </svg>
                    </div>
                    <div>
                      <h1 className="text-2xl font-bold text-gray-700 font-K2D">
                        Gestion des Partenaires
                      </h1>
                      <p className="text-gray-600 text-lg mt-2">
                        Administrez vos partenaires et leurs accès
                      </p>
                    </div>
                  </div>
                  
                  {!openDetails && (
                    <button
                      className="px-6 py-3 bg-yellow-trio text-grey-trio cursor-pointer font-semibold rounded-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 flex items-center gap-3"
                      onClick={() => {
                        setDisplayDiv(true);
                        setOpenDetails(true);
                        setModePartner("create");
                      }}
                    >
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                      </svg>
                      Créer un partenaire
                    </button>
                  )}
                </div>
              </div>

              {/* Table des partenaires avec design moderne */}
              <div className="w-full bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden">
                <SuperAdminPartnerTable
                  closeModal={closeModal}
                  openModal={openModal}
                />
              </div>
            </>
          )}

          {/* Section Logs */}
          {pathVisible === "logs" && (
            <>
              {/* Header Section avec design moderne */}
              <div className="w-full bg-white rounded-2xl shadow-lg p-6 my-6 border border-gray-100">
                <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6">
                  <div className="flex items-center gap-4">
                    <div className="p-3 bg-gradient-to-br from-yellow-trio to-yellow-400 rounded-xl shadow-lg">
                      <svg className="w-7 h-7 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                    </div>
                    <div>
                      <h1 className="text-2xl font-bold text-gray-700 font-K2D">
                        Journal des Activités
                      </h1>
                      <p className="text-gray-600 text-lg mt-2">
                        Consultez et téléchargez l'historique des actions
                      </p>
                    </div>
                  </div>
                  
                  <button
                    className="px-6 py-3 bg-gradient-to-r from-yellow-trio to-yellow-400 text-gray-700 cursor-pointer font-semibold rounded-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 flex items-center gap-3"
                    onClick={() => handleDownloadLogs()}
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    Télécharger les logs
                  </button>
                </div>
              </div>

              {/* Table des logs avec design moderne */}
              <div className="w-full bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden">
                <SuperAdminLogsTable />
              </div>
            </>
          )}

          {/* Section par défaut - Dashboard */}
          {!pathVisible && (
            <div className="w-full h-full flex flex-col items-center justify-center">
              <div className="text-center">
                <div className="inline-flex items-center justify-center w-24 h-24 bg-gradient-to-br from-light-lavender to-dark-lavender rounded-full mb-8 shadow-2xl">
                  <svg className="w-12 h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                  </svg>
                </div>
                <h1 className="text-3xl font-bold text-gray-700 mb-4 font-K2D">
                  Tableau de Bord Super Admin
                </h1>
                <p className="text-xl text-gray-600 max-w-2xl">
                  Sélectionnez une section dans le menu de navigation pour commencer à administrer votre plateforme
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SuperAdminHome;
